module.exports = __webpack_public_path__ + "img/home-teatro.30a2a69a.jpg";